import { ApiResponse, Meta, TicketManagerConversation, TicketManagerMessage } from '@vision/ui/interfaces';

export interface TicketManagerConversationResponseDto {
  created_at: string;
  id: string;
  subject: string;
}

export interface TicketManagerMessageResponseDto {
  content: string;
  created_at: string;
  from: string | null;
  id: string;
  sent_at: string | null;
  to: string;
}

export interface TicketManagerConversationCollectionResponseEnvelope {
  data?: TicketManagerConversationResponseDto[] | null;
  meta?: Meta | null;
  object: 'collection';
  url?: string;
}

export interface TicketManagerMessageCollectionResponseEnvelope {
  data?: TicketManagerMessageResponseDto[] | null;
  meta?: Meta | null;
  object: 'collection';
  url?: string;
}

function mapTicketManagerConversation(dto: TicketManagerConversationResponseDto): TicketManagerConversation {
  return {
    createdAt: dto.created_at,
    id: dto.id,
    subject: dto.subject,
  };
}

function mapTicketManagerMessage(dto: TicketManagerMessageResponseDto): TicketManagerMessage {
  return {
    content: dto.content,
    createdAt: dto.created_at,
    from: dto.from,
    id: dto.id,
    sentAt: dto.sent_at,
    to: dto.to,
  };
}

export function normalizeTicketManagerTicketConversationsResponse(
  response: TicketManagerConversationCollectionResponseEnvelope,
): ApiResponse<TicketManagerConversation[]> {
  return {
    data: Array.isArray(response.data) ? response.data.map(mapTicketManagerConversation) : [],
    meta: response.meta ?? null,
    object: 'collection',
  };
}

export function normalizeTicketManagerTicketConversationMessagesResponse(
  response: TicketManagerMessageCollectionResponseEnvelope,
): ApiResponse<TicketManagerMessage[]> {
  return {
    data: Array.isArray(response.data) ? response.data.map(mapTicketManagerMessage) : [],
    meta: response.meta ?? null,
    object: 'collection',
  };
}
